var _style, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Mongodb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5D4037;}\n\t.st1{fill:#4CAF50;}\n\t.st2{fill:#DCEDC8;}\n\t.st3{fill:#81C784;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84,34.6C84,75.6,48,88,48,88S12,75.6,12,34.6c0-5,0.4-9.2,0.8-12.6c0.6-5,4-9,8.8-10.2C27.8,10,37.6,8,48,8 s20.2,2,26.6,3.8c4.8,1.2,8.2,5.4,8.8,10.2C83.6,25.4,84,29.8,84,34.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,14c9.8,0,19,2,25,3.6c2.4,0.6,4,2.6,4.4,5.2c0.4,3.8,0.6,7.8,0.6,11.8c0,31.2-23,43.8-30,46.8 c-7-3.2-30-15.8-30-46.8c0-4,0.2-8,0.6-11.8c0.2-2.6,2-4.6,4.4-5.2C29,16,38.2,14,48,14 M48,8c-10.4,0-20.2,2-26.6,3.8 c-4.6,1.2-8.2,5.4-8.6,10.2c-0.4,3.4-0.8,7.8-0.8,12.6C12,75.6,48,88,48,88s36-12.4,36-53.4c0-5-0.4-9.2-0.8-12.6 c-0.6-5-4-9-8.8-10.2C68.2,10,58.4,8,48,8L48,8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46,56h4v16h-4V56z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,20c0,0-12,10-12,26c0,10.4,6.6,17,10,20l2-6l2,6c3.4-3,10-9.6,10-20C60,30,48,20,48,20z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48,20c0,0-12,10-12,26c0,10.4,6.6,17,10,20l2-6V20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Mongodb);
export default __webpack_public_path__ + "static/media/icons8-mongodb.fd6a539725dae2e021986edcb9f775e4.svg";
export { ForwardRef as ReactComponent };